// Check-ins: create, list, vibe/solo followup, activity events.
import { apiCall, buildIdentityHeaders } from "./core";

export const checkInAPI = {
  create: async (checkInData = {}, token) => {
    const {
      venueId,
      placeId,
      city,
      arrivalWindow,
      outcome,
      notes,
      channel,
      metadata,
      token: tokenFromPayload,
      userId,
      latitude,
      longitude,
      overrideDistanceGate,
    } = checkInData || {};

    const authToken = token || tokenFromPayload || null;
    const payload = {
      venue_id: venueId,
      place_id: placeId,
      city,
      arrival_window: arrivalWindow,
      outcome,
      notes,
      channel,
      ...(metadata ? { metadata } : {}),
      ...(latitude != null && longitude != null
        ? { latitude: Number(latitude), longitude: Number(longitude) }
        : {}),
      ...(overrideDistanceGate ? { override_distance_gate: true } : {}),
    };

    return await apiCall("/check-ins", {
      method: "POST",
      body: JSON.stringify(payload),
      headers: buildIdentityHeaders({ token: authToken, userId }),
    });
  },

  /** Google Places autocomplete proxy for the “add my own place” check-in flow. */
  placesAutocomplete: async ({ input, city = null, token = null, userId = null } = {}) =>
    apiCall("/check-ins/places-autocomplete", {
      method: "POST",
      body: JSON.stringify({ input, ...(city ? { city } : {}) }),
      headers: buildIdentityHeaders({ token, userId }),
    }),

  getUserCheckIns: async (userId, token = null) => {
    return await apiCall(`/check-ins?user_id=${userId}`, {
      headers: buildIdentityHeaders({ token, userId }),
    });
  },

  awardVipPass: async (source = "stag", token) => {
    const sourceValue =
      typeof source === "string" ? source : source?.source || "stag";
    const authToken =
      token || (typeof source === "object" ? source?.token : null) || null;

    return await apiCall("/users/me/vip-pass", {
      method: "POST",
      body: JSON.stringify({ source: sourceValue }),
      headers: authToken ? { Authorization: `Bearer ${authToken}` } : undefined,
    });
  },
};

export const checkInFollowupAPI = {
  getInbox: async ({ token = null, userId = null } = {}) =>
    apiCall("/check-in-followups/inbox", {
      headers: buildIdentityHeaders({ token, userId }),
    }),

  submitVibe: async ({ checkInId, vibeStatus, token = null, userId = null }) =>
    apiCall("/check-in-pulse/vibe", {
      method: "POST",
      body: JSON.stringify({ check_in_id: checkInId, vibe_status: vibeStatus }),
      headers: buildIdentityHeaders({ token, userId }),
    }),

  submitSoloNote: async ({
    checkInId,
    soloNote,
    token = null,
    userId = null,
  }) =>
    apiCall("/check-in-pulse/solo-note", {
      method: "POST",
      body: JSON.stringify({ check_in_id: checkInId, solo_note: soloNote }),
      headers: buildIdentityHeaders({ token, userId }),
    }),
};

export const activityEventsAPI = {
  log: async ({
    venueId,
    eventType,
    channel = null,
    metadata = null,
    token = null,
    userId = null,
  }) =>
    apiCall("/activity-events", {
      method: "POST",
      body: JSON.stringify({
        venue_id: venueId,
        event_type: eventType,
        ...(channel ? { channel } : {}),
        ...(metadata && typeof metadata === "object" ? { metadata } : {}),
      }),
      headers: buildIdentityHeaders({ token, userId }),
    }),

  list: async ({ limit = 30, token = null, userId = null } = {}) => {
    const q = Number.isFinite(limit)
      ? `?limit=${encodeURIComponent(String(limit))}`
      : "";
    return apiCall(`/activity-events${q}`, {
      headers: buildIdentityHeaders({ token, userId }),
    });
  },
};
